var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#015EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.1128L21.5577 13.1705L22.5 12.2283L23.4423 13.1705L22.5 14.1128ZM23.8328 26.1078C23.8328 26.4613 23.6923 26.8003 23.4424 27.0503C23.1924 27.3002 22.8535 27.4406 22.5 27.4406C22.1465 27.4406 21.8075 27.3002 21.5576 27.0503C21.3076 26.8003 21.1672 26.4613 21.1672 26.1078H23.8328ZM14.8938 19.8345L21.5577 13.1705L23.4423 15.0551L16.7783 21.719L14.8938 19.8345ZM23.4423 13.1705L30.1062 19.8345L28.2216 21.719L21.5577 15.0551L23.4423 13.1705ZM23.8328 14.1128V26.1078H21.1672V14.1128H23.8328Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1707 28.7734V30.1062C13.1707 30.8132 13.4515 31.4912 13.9514 31.9911C14.4513 32.4909 15.1293 32.7718 15.8362 32.7718H29.164C29.871 32.7718 30.549 32.4909 31.0489 31.9911C31.5487 31.4912 31.8296 30.8132 31.8296 30.1062V28.7734",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBtn);
export default __webpack_public_path__ + "static/media/upload_btn.5389531b41e181989d2f375b53b5ee14.svg";
export { ForwardRef as ReactComponent };